module.exports = __webpack_public_path__ + "static/media/nwt84.a8e15c1e.jpg";